export default "__VITE_ASSET__6bf1120e__"